import { newsfeedPath } from '../utils/endpoints';
import { CreateDataByIndexedDB, GetAllDataByIndexedDB } from '../indexed/index';
import moment from 'moment';
import axiosInstance from '../helpers/interceptor';
import { userHotelDetails } from '../helpers/handleBrandAndHotelData';

export const fetchNewsfeed = async (
  q: string,
  filterBy: string,
  pageNumber: number,
  categoryId: number | undefined,
  userId: number | undefined,
  startDate,
  endDate
) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();

  let endpointUrl = `${newsfeedPath}/news-feed?type=${filterBy}&isClientApp=true&page=${pageNumber}&pageSize=10&sort=-id`;
  if (q) {
    endpointUrl += `&q=${q.trim()}`;
  }
  if (categoryId) {
    endpointUrl += `&templateCategoryId=${categoryId}`;
  }
  if (userId) {
    endpointUrl += `&userId=${userId}`;
  }
  if (startDate) {
    endpointUrl += `&startDate=${moment(startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss')}`;
  }
  if (endDate) {
    endpointUrl += `&endDate=${moment(endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss')}`;
  }

  if (filterBy === 'hotel') {
    endpointUrl += `&hotelId=${selectedHotel}`;
  } else if (filterBy === 'brand') {
    endpointUrl += `&brandId=${selectedBrand}`;
  }
  const doesUpdate = async () => {
    const { data } = await axiosInstance.get(endpointUrl);
    CreateDataByIndexedDB(endpointUrl, data, selectedHotel);
  };

  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(endpointUrl, selectedHotel);
  if (OfflineData) {
    dataD = OfflineData;
    doesUpdate();
  } else {
    const { data } = await axiosInstance.get(endpointUrl);
    dataD = data;
    CreateDataByIndexedDB(endpointUrl, data, selectedHotel);
  }
  return dataD;
};

export const getNewsfeedById = async (id: number | string) => {
  const { selectedHotel } = userHotelDetails();

  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${newsfeedPath}/${id}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(`${newsfeedPath}/${id}`);
    dataD = data;
    CreateDataByIndexedDB(`${newsfeedPath}/${id}`, data, selectedHotel);
  }
  return dataD;
};
